import React, { useState, useEffect, useContext } from "react";
import { FiSearch } from "react-icons/fi";
import SessionContext from "../../../contexts/sessionContext";

import ProcessComp from "../../../components/Process";

import { Container, Content } from "./styles";

import VisaoGeral from "../../../components/VisaoGeralGerenciamento";

import api from "../../../services/api";

interface ProcessProps {
	id: number;
	proponent_name: string;
	cpf: string;
	createdAt: string;
	typist_one_id?: number;
	typist_two_id?: number;
	analist_id: number;
	analytic?: string;
	status?: number;
	typist_one: any;
	typinst_two: any;
}

function AdminProcessManagement() {
	const [searchTerm, setSearchTerm] = useState("");

	const [process, setProcess] = useState<ProcessProps[]>();

	useEffect(() => {
		const process_data = async () => {
			try {
				const { data } = await api.get("/data/process");
				
				if (data.data) setProcess(data.data);
			} catch (error) {
				return error;
			}
		};

		process_data();
	}, []);

	const { user } = useContext(SessionContext);

	return (
		<Container>
			<Content>
				<div className='header'>
					<div className='user-info'>
						<div>
							<p id='func'>Administrador</p>
							<p id='name'>{user.name}</p>
						</div>

						<div className='Search-container'>
							<FiSearch />
							<input
								type='text'
								id='searchBox'
								placeholder='Buscar por nome ou cpf...'
								onChange={(e) => setSearchTerm(e.target.value)}
							/>
						</div>
					</div>
					<div className='header-manager'>
						<VisaoGeral
							data={process?.map((item) => item.status)}
						/>
					</div>
				</div>
				<div className='process-manager'>
					<div>
						<p id='process-title'>Processos</p>
					</div>
					<table className='table-wrapper'>
						<tr>
							<th>Nome do Proponente</th>
							<th>CPF</th>
							<th>Data</th>
							<th>Hora</th>
							<th>Digitador 1</th>
							<th>Digitador 2</th>
							<th>Analista</th>
							<th>Status</th>
							<th></th>
						</tr>

						{process &&
							process
								.filter((item) => {
									if (searchTerm === "") {
										return item;
									} else if (
										item.proponent_name
											.toLowerCase()
											.includes(searchTerm.toLowerCase())
									) {
										return item;
									} else if (item.cpf.includes(searchTerm)) {
										return item;
									}
								})
								.map((item) => {
									return (
										<ProcessComp
											process={item}
											key={item.id}
										/>
									);
								})}
					</table>
				</div>
			</Content>
		</Container>
	);
}

export default AdminProcessManagement;
